export const main = (filters) => [
  // { text: '', value: 'actions', width: 100 },

  {
    text: 'Mã NS',
    align: 'center',
    value: 'code',
    width: '100px',
    filter: value => {
      const f = filters.find(x => x.name === 'code')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },
  // {
  //   text: 'Avatar',
  //   align: 'center',
  //   value: 'avatar',
  //   width: '100px',
  //   filter: value => true
  // },
  
  {
    text: 'Trạng thái',
    align: 'start',
    value: 'status',
    width: '10rem',
    filter: value => {
      const f = filters.find(x => x.name === 'status')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Tên NS',
    align: 'start',
    value: 'name',
    width: '12rem',
    filter: value => {
      const f = filters.find(x => x.name === 'name')?.value
      if (!f) return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Giới tính',
    align: 'start',
    value: 'gender',
    width: '50px',
    filter: value => true
  },

  {
    text: 'Ngày sinh',
    align: 'start',
    value: 'birthDay',
    width: '8rem',
    filter: value => true
  },
  
  {
    text: 'Ngày nhân việc',
    align: 'start',
    value: 'hireDate',
    width: '10rem',
    filter: value => { 
      return true
    }
  },
  
  {
    text: 'Chức danh',
    align: 'start',
    value: 'positionStateName',
    width: '10rem',
    filter: value => { 
      return true
    }
  },

  // {
  //   text: 'Mã Store',
  //   align: 'start',
  //   value: 'storeAlias',
  //   width: '85px',
  //   filter: value => {
  //     const f = filters.find(x => x.name === 'storeAlias')?.value
  //     if (!f) return true
  //     return value?.toLowerCase().includes(f.toLowerCase())
  //   }
  // },

  {
    text: 'Tên store',
    align: 'center',
    value: 'storeName',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'storeName')?.value
      if (f === undefined || f === null || f === '') return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },

  {
    text: 'Vùng',
    align: 'center',
    value: 'deptArea',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'deptArea')?.value
      if (f === undefined || f === null || f === '') return true
      return value?.toLowerCase().includes(f.toLowerCase())
    }
  },
  
  {
    text: 'Mã SM',
    align: 'center',
    value: 'storeManagerCode',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'storeManagerCode')?.value
      if (!f) return true
      return value === f
    }
  },
  {
    text: 'Tên SM',
    align: 'center',
    value: 'storeManagerName',
    width: '6rem',
    filter: value => {
      const f = filters.find(x => x.name === 'storeManagerName')?.value
      if (!f) return true
      return value === f
    }
  }
]